export function getUrlParam(queryString, name){
   var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
   var r = queryString.substr(1).match(reg);
   if (r != null) return unescape(r[2]);
   return null;
}

export function getTreeData (data) {
   let parents = data.filter(item => item.pid === undefined || item.pid === null || item.pid === "");
   let children = data.filter(item => item.pid !== undefined  && item.pid !== null && item.pid !== "");
   let translator = (parents, children) => {
      parents.forEach( (parent) => {
         children.forEach((current,index) => {
            if(parent.id === current.pid) {
               let temp = JSON.parse(JSON.stringify(children));
               temp.splice(index,1);
               translator([current], temp);
               typeof parent.children !== "undefined" ? parent.children.push(current) : parent.children = [current]
            }
         })
      })
   }

   translator(parents,children);
   return parents
}